export const daysFilterTemplateId = state => state.daysFilterTemplateId
